import { render } from "./GigComponent.vue?vue&type=template&id=3f6f8ba6"
import script from "./GigComponent.vue?vue&type=script&lang=js"
export * from "./GigComponent.vue?vue&type=script&lang=js"

import "./GigComponent.vue?vue&type=style&index=0&id=3f6f8ba6&lang=css"

import exportComponent from "/var/www/gigs.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__